/**
 * 결제 결과 페이지 컨텍스트 복귀 네비게이션 문구 (#657).
 *
 * 3DS 거절 복귀(`/payment/result?source=3ds&outcome=declined`, orderId 부재) 시
 * '홈으로 돌아가기' 가 진짜 홈(`/`) 고정이라 테이블 오더 세션/매장으로 복귀할 수단이 없었다.
 * 활성 테이블 세션 또는 픽업(장바구니) 컨텍스트가 있으면 해당 매장으로 복귀하는 버튼으로
 * 동작을 전환하며, 이때 라벨도 '매장으로 돌아가기' 류로 함께 전환한다.
 *
 * 15개 지원 locale 전수 정의 — i18n drift 는 paymentResultNav.test.ts 가 회귀 게이트.
 * (#650 paymentResult3ds 패턴 정합 — 페이지 본문 legacy 3로케일 사전과 별개 파일)
 *
 * @see src/components/payment/PaymentResultPage.tsx
 */
import type { Locale } from '@/config/locales';

export interface PaymentResultNavTranslation {
  /** 컨텍스트 복귀 버튼 라벨 — 테이블 세션/픽업 매장으로 돌아가기 */
  returnToStore: string;
}

export const paymentResultNavTranslations: Record<Locale, PaymentResultNavTranslation> = {
  es: {
    returnToStore: 'Volver a la tienda',
  },
  en: {
    returnToStore: 'Back to the store',
  },
  ko: {
    returnToStore: '매장으로 돌아가기',
  },
  pt: {
    returnToStore: 'Voltar à loja',
  },
  fr: {
    returnToStore: 'Retourner au commerce',
  },
  zh: {
    returnToStore: '返回门店',
  },
  ja: {
    returnToStore: '店舗に戻る',
  },
  hi: {
    returnToStore: 'स्टोर पर वापस जाएं',
  },
  de: {
    returnToStore: 'Zurück zum Geschäft',
  },
  it: {
    returnToStore: 'Torna al negozio',
  },
  ru: {
    returnToStore: 'Вернуться в заведение',
  },
  ar: {
    returnToStore: 'العودة إلى المتجر',
  },
  vi: {
    returnToStore: 'Quay lại cửa hàng',
  },
  th: {
    returnToStore: 'กลับไปที่ร้านค้า',
  },
  nl: {
    returnToStore: 'Terug naar de winkel',
  },
};
